<template>
  <div>
    <!-- 搜索栏 -->
    <form action="/">
      <van-sticky>
        <van-search
          v-model="queryData"
          show-action
          shape="round"
          @search="onSearch"
          background="#fff"
          placeholder="请输入搜索账号"
        ></van-search>
        <!-- <vant-icon name="cross"></vant-icon> -->
      </van-sticky>
    </form>
    <!-- 渲染html -->
    <div :class="wrapClass" @click="clickWrap">
      <!-- 列表 -->
      <!-- <van-skeleton title avatar :row="3"> -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          offset="0"
          @load="loadData"
          error-text="请求失败，点击重新加载"
        >
          <van-cell v-for="(item, index) in userList" :key="index">
            <div class="demo-preview">
              <div class="demo-left">
                <img :src="item.avatar" v-if="item.avatar" />
                <img src="@/assets/user.png" v-else />
              </div>

              <div class="flex_view_space">
                <div class="demo-content">
                  <div>{{ item.realName }}</div>
                </div>
                <div>
                  <van-button
                    type="info"
                    size="small"
                    :data-sid="item"
                    v-if="item.bstatus == 1"
                    @click="unbind(item)"
                    >解绑</van-button
                  >
                  <van-button
                    v-else
                    type="info"
                    size="small"
                    @click="clickOn(item)"
                    :data-sid="item"
                    >绑定</van-button
                  >
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>

      <div v-if="isFlag">
        <!-- 搜索提示 -->
        <van-empty image="search" description="暂无数据" />
      </div>

      <!-- </van-skeleton> -->
    </div>
    <van-dialog
      v-model="showFlag"
      title="确认绑定账号"
      use-slot
      show-cancel-button
      :beforeClose="beforeClose"
    >
      <van-form>
        <van-field
          v-if="showFlag"
          v-model="username"
          name="姓名"
          label="姓名"
          placeholder="请填写该账号姓名"
          :rules="[{ required: true, message: '请填写该账号姓名' }]"
        />
      </van-form>
    </van-dialog>
    <van-toast id="van-toast" />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { Base64 } from "../utils/base64.js";
import { constants } from "zlib";
import { Dialog, Toast } from "vant";
export default {
  components: {},
  data() {
    return {
      data: {},
      settingShow: false,
      bgColor: "white", // coral  palegreen  black
      wrapClass: { wrap: true, "bg-white": true },
      lineClass: { "line-white": true },
      popupClass: { "van-popup": true, "bg-white": true },
      textFont: 16, //10~20  step 2
      titleClass: { title: true, "font-20": true },
      assistClass: { assist: true },
      authorClass: { author: true },
      othertitleClass: { "other-title-v": true, "font-20": true },
      contentClass: { "font-16": true, content: true, widthImg: true },
      articleitemClass: { "articleList-item": true, qyl_font16: true }, //qylupdata 3/4 字体行高
      setType: "font", //bg
      tipMsg: "",
      showVip: false,
      fixed_box: { fixed_box: true },
      // loading:false,
      query: null, //参数
      isRegister: false, //未登录
      isNew: false, //是否是第一次阅读
      queryData: "", //搜索的值
      userList: [], //学生信息列表
      loading: false,
      finished: false,
      refreshing: false,
      parentStudent: "", //家长关联表
      showFlag: false,
      username: "", //用户正确姓名 验证
      show: true,
      isFlag: false, //暂无更多
      parentId: "", //家长id 家长只能绑定两个账号
      studentId: "", //学生id
      userimg: "@/assets/user.png",
      page: {
        total: 0,
        size: 10,
        current: 1,
      },
    };
  },
  watch: {
    bgColor: function (val) {
      let name1 = "bg-" + val;
      let name2 = "line-" + val;
      this.wrapClass = { wrap: true, [name1]: true };
      this.lineClass = { [name2]: true };
      this.popupClass = { "van-popup": true, [name1]: true };
      this.fixed_box = { fixed_box: true };
      this.fixed_box = { fixed_box: true };
    },
    textFont: function (val) {
      let v = Math.round(val); //四舍五入
      let name1 = "font-" + v;
      let name2 = "font-" + (v + 4);
      // let name3 = 'font-'+ (val==10?val:val-2);
      let name3 = "font-" + (v == 10 ? v : v - 1);
      this.contentClass = { [name1]: true, content: true };
      this.articleitemClass = { "articleList-item": true, [name1]: true };
      this.titleClass = { title: true, [name2]: true };
      this.assistClass = { assist: true };
      this.authorClass = { author: true };
      this.othertitleClass = { "other-title-v": true, [name2]: true };
    },
  },
  created() {
    // 对浏览器的UserAgent进行正则匹配，不含有微信独有标识的则为其他浏览器
    // let ua = navigator.userAgent.toLowerCase();
    // let isWeixin = ua.indexOf("micromessenger") != -1;
    // if (!isWeixin) {
    //   window.location.href =
    //     "https://open.weixin.qq.com/connect/oauth2/authorize?appid=888";
    // }
  },
  mounted() {
    this.parentId = this.$route.query.parentId;
    this.loadData(); //请求列表
  },
  methods: {
    /**
     * @param strBirthday：指的是出生日期，格式为"2020-06-30 00:00:00"
     */
    GetAge(strBirthday) {
      if (!strBirthday) {
        return "数据缺失";
      }
      var returnAge;
      strBirthday = strBirthday.split(" ")[0];
      const strBirthdayArr = strBirthday.split("-");
      const birthYear = strBirthdayArr[0];
      const birthMonth = strBirthdayArr[1];
      const birthDay = strBirthdayArr[2];
      const d = new Date();
      const nowYear = d.getFullYear();
      const nowMonth = d.getMonth() + 1;
      const nowDay = d.getDate();
      if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0周岁
      } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
          if (nowMonth == birthMonth) {
            var dayDiff = nowDay - birthDay; //日之差
            if (dayDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          } else {
            var monthDiff = nowMonth - birthMonth; //月之差
            if (monthDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          }
        } else {
          returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
        }
      }
      return returnAge + "岁"; //返回周岁年龄
    },

    //初始化请求  已绑定列表
    loadData() {
      //不存在家长id
      this.isFlag = false;
      let parentId = this.parentId;
      if (this.refreshing) {
        this.userList = [];
        this.refreshing = false;
      }
      let size = this.page.size;
      let current = this.page.current;
      let query =
        "?parentId=" + parentId + "&pageNum=" + current + "&pageSize=" + size;
      const options = {
        method: "GET",
        url: this.$api.getBindPage + query,
      };
      this.$http(options)
        .then((res) => {
          if (res.data.code === 200) {
            this.loading = false;
            let result = res.data.data;
            let arr = result.records;
            arr.forEach((item) => {
              if (item.birthday) {
                item.age = this.GetAge(item.birthday);
              }
            });
            if (this.page.current > 1) {
              this.userList = this.userList.concat(arr); //追加数据
            } else {
              this.userList = arr; //第一页的数据
            }
            //当前数据限制
            if (this.userList.length == 0) {
              console.log("数据为空数组");
              this.isFlag = true;
              this.loading = true;
              this.finished = true;
              this.refreshing = false;
              return;
            }
            //   // 如果当前页数 = 总页数，则已经没有数据
            if (result.current === result.pages) {
              this.finished = true;
              this.finishedText = "- 没有更多了-";
            }
            // 如果总页数大于当前页码，页码+1
            if (result.pages > this.page.current) {
              this.page.current++;
            }
          } else {
            this.$toast(res.data.msg);
            this.isFlag = true;
            this.loading = true;
            this.finished = true;
          }
        })
        .catch((res) => {
          console.log("error data::", res);
          this.loading = true;
        });
    },
    //下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.userList = [];
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // this.loading = true;
      // this.page.current = 1;
      // this.loadData();
    },
    clickWrap() {
      this.settingShow = false; //设置字体隐藏
    },
    // 查询账号
    onSearch(val) {
      if (!this.queryData) {
        Toast("请输入账号搜索");
        return;
      }
      this.isFlag = false;
      let query = "?phone=" + this.queryData;
      const options = {
        method: "GET",
        url: this.$api.getUserByPhone + query,
      };
      this.$http(options)
        .then((res) => {
          if (res.data.code === 200) {
            //加载结束
            this.loading = false;
            let resdata = res.data.data;
            // resdata.forEach(item => {
            //   if (item.birthday) {
            //     item.age = this.GetAge(item.birthday); //将日期转换为年龄
            //   }
            // });
            this.userList = [resdata] || {}; //学生列表
            if (this.userList.length == 0) {
              this.isFlag = true;
            }
            console.log("userList==========", this.userList);
          } else {
            Dialog({
              message: res.data.msg,
              showConfirmButton: false,
              showCancelButton: false,
            });
          }
        })
        .catch((res) => {
          console.log("error data::", res);
          this.loading = true;
        });
    },
    //确认 弹窗出现
    clickOn(value) {
      // this.showFlag = true; //校验弹窗
      this.studentId = value.userId; // 学生id
      this.bind();
    },
    //绑定确认
    beforeClose(action, done) {
      if (action === "confirm") {
        this.bind();
        setTimeout(done, 1000);
      } else if (action === "cancel") {
        done(); //关闭
      }
      this.username = "";
    },
    //绑定学员
    bind(e) {
      Dialog.confirm({
        title: "绑定",
        message: "确认绑定该学生吗？",
      })
        .then(() => {
          let studentId = this.studentId;
          let parentId = this.parentId;
          let params = {
            userId: studentId,
            parentId: parentId,
          };
          const options = {
            method: "POST",
            url: this.$api.bindStudents,
            data: params,
          };
          this.$http(options)
            .then((res) => {
              if (res.data.code === 200) {
                //加载结束
                this.queryData = ""; //清空搜索栏
                // this.showFlag = false; //关闭弹窗
                this.loading = false;
                this.$toast(res.data.msg);
                // 清空列表数据
                this.finished = false;
                this.userList = []; //清空
                this.page.current = 1;
                this.loadData(); //重新调用已绑定列表
              } else {
                this.$toast(res.data.msg);
              }
            })
            .catch((res) => {
              console.log("error data::", res);
              this.loading = true;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //解绑学员
    unbind(values) {
      Dialog.confirm({
        title: "解绑",
        message: "确认解绑该学生吗？",
      })
        .then(() => {
          let params = {
            id: values.id,
          };
          const options = {
            method: "POST",
            url: this.$api.unboundStudents,
            data: params,
          };
          this.$http(options)
            .then((res) => {
              if (res.data.code === 200) {
                //加载结束
                this.loading = false;
                this.$toast(res.data.msg);
                // 清空列表数据
                this.finished = false;
                this.userList = []; //清空
                this.page.current = 1;
                this.loadData(); //重新加载已绑定的列表
              } else {
                this.$toast(res.data.msg);
              }
            })
            .catch((res) => {
              console.log("error data::", res);
              this.loading = true;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style scoped>
@import "../assets/iconfont/font_set_read_bar/iconfont.css";
@import "../styles/style.css";
@import "../styles/common.css";
.wrap {
  /* padding: 20px; */
  /* padding-top: 100px; html高度过大 3/4 qylupdata */
  padding-bottom: 50px;
}
.nav {
  box-shadow: 5px 5px 1px #f2f2f2;
}
.content {
  letter-spacing: 1.5px;
}
.assist {
  font-size: 14px;
  line-height: 30px;
}
.author {
  font-size: 12px;
  line-height: 40px;
}
.line-black {
  background-color: #969696;
  min-height: 1px;
}
.bg-black {
  background-color: #505050;
  color: #969696;
}
.line-red {
  background-color: #ff3e3e;
  min-height: 1px;
}
.line-palegreen {
  background-color: #7e7e7e;
  min-height: 1px;
}
.bg-palegreen {
  background-color: #d8ffbd;
  color: #000000;
}
.line-coral {
  background-color: #8d4b00;
  min-height: 1px;
}
.bg-coral {
  background-color: #ffcd94;
  color: #000000;
}
.line-white {
  background-color: #dadada;
  min-height: 1px;
}
.bg-white {
  background-color: #ffffff;
  color: #292929;
}
.van-overlay {
  background: none !important;
  height: 0px !important;
}
.font-14 {
  font-size: 14px;
  line-height: 24px;
}
.qyl_font16 {
  font-size: 16px;
  line-height: 40px;
}

.other-title-v {
  display: flex;
  margin: 10px 0px;
}
.other-icon {
  width: 2%;
  margin: 4px 6px;
  margin-left: 0px;
  border-radius: 2px;
}
.articleList-item {
  width: 100%;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
}
.van-popup {
  min-height: 8%;
  /* box-shadow: 0px -2px 10px #ececec; */
}
.van-cell::after {
  border: none !important;
}
.popup-mask {
  background: none !important;
  height: 0px !important;
}
.set-bar {
  display: flex;
  flex: 1;
  height: 50px;
  align-items: center;
  justify-content: space-around;
}
.set-font-v {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 20px;
  margin-bottom: 20px;
  min-height: 50px;
}
.van-slider {
  margin: 0px 10px;
}
.zi-add::after {
  content: "-";
}
.zi-sub::after {
  content: "+";
}

.fixed_box {
  position: fixed;
  top: 30%;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  /* text-align: -webkit-center; */
}

image {
  overflow: visible;
}
.demo-preview {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px;
}
.demo-left {
  width: 20%;
  display: inline-block;
}
.demo-preview img {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  width: 41px;
  height: 41px;
  margin-right: 16px;
  border: 4px solid rgba(240, 240, 240, 1);
  border-radius: 50%;
}
.demo-preview .flex_view_space {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.demo-preview .demo-content {
  display: block;
  text-align: left;
  font-size: 12px !important;
}
.demo-preview .demo-content h3 {
  margin: 0;
  /* font-size: 18px; */
  line-height: 20px;
}
.demo-preview .demo-content .flex_view_spance {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/view/bind.vue